var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaptainInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.8956 19.0176C14.8956 19.6896 14.6716 20.1376 14.0668 20.1376C13.5068 20.1376 13.2604 19.7344 13.2604 18.9952V9.09438C13.2604 8.35518 13.4172 7.99678 14.0444 7.99678C14.6716 7.99678 14.8956 8.37758 14.8956 9.09438V12.0288H17.382V9.04958C17.382 7.41438 17.0684 5.57758 14.2908 5.57758H13.7084C11.4236 5.57758 10.6844 7.21278 10.6844 8.91518V19.0848C10.6844 20.7648 11.2444 22.6016 13.798 22.6016H14.358C16.7996 22.6016 17.382 20.7872 17.382 18.9952V15.1424H14.8956V19.0176Z",
    fill: "#39207C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptainInactive);
export default __webpack_public_path__ + "static/media/captain_inactive.5f001547fb48bba8c279f56a22d968ac.svg";
export { ForwardRef as ReactComponent };